'use client';
import { COLOR_THEMES, ColorThemeType, ICONS } from '@qlevr/shared/constants';
import { SubMenuTypeListInterface } from '@qlevr/shared/interfaces';
import { Accordion, AccordionContent, AccordionPanel, AccordionTitle, Flowbite } from 'flowbite-react';
import isEmpty from 'lodash.isempty';
import { useState } from 'react';
import TitleImageCard from '../card/title-image-card/title-image-card';
import { accordionTheme } from '../content-blocks/accordion/accordion-theme';
import IconRenderer from '../icons/icon-renderer.component';
import LinkRenderer from '../link/link-renderer';
import clsx from 'clsx';

export interface MenuDrawerAccordionsProps {
  subMenu: SubMenuTypeListInterface[] | null;
  theme: ColorThemeType;
}

export function MenuDrawerAccordions(props: MenuDrawerAccordionsProps) {
  const { subMenu, theme } = props;
  const [accordionStates, setAccordionStates] = useState(subMenu?.map(() => true));
  const handleClick = (index: number) => {
    setAccordionStates((prev) => prev?.map((state, i) => (i === index ? !state : true)));
  };

  if (!subMenu || isEmpty(subMenu)) {
    return null;
  }

  const menuDrawerAccordionTheme = {
    ...accordionTheme,
    accordion: {
      ...accordionTheme.accordion,
      root: {
        ...accordionTheme.accordion.root,
        base: 'border-none',
      },
    },
  };

  return (
    <Flowbite theme={{ theme: menuDrawerAccordionTheme }}>
      <Accordion flush className="" collapseAll>
        {subMenu.map((item, index) => (
          <AccordionPanel key={index}>
            <div className="border-b border-slate-300 first:border-t last:border-b-0">
              <div className="flex justify-between" onClick={() => handleClick(index)}>
                <AccordionTitle className="py-2">
                  <div className="flex w-full items-center justify-between">
                    <div className="pointer-events-none text-left">{item.link && <LinkRenderer cta={item.link} />}</div>
                    <div className="w-6 shrink-0 transform cursor-pointer text-black">
                      {accordionStates?.[index] ? (
                        <IconRenderer icon={ICONS.chevronDown} />
                      ) : (
                        <IconRenderer icon={ICONS.chevronUp} />
                      )}
                    </div>
                  </div>
                </AccordionTitle>
              </div>

              <AccordionContent className={clsx(theme.background, '-mx-5')}>
                <div className="space-y-2 px-5 py-4">
                  <ul className="grid grid-cols-2 gap-2">
                    {item?.subMenuItems?.map((cardItem, cardIndex) => (
                      <li key={`${index}-${cardIndex}`}>
                        <TitleImageCard
                          className="h-full"
                          theme={COLOR_THEMES.light}
                          cta={{
                            ...cardItem.cta,
                            size: 'text-sm',
                            className: 'font-bold normal-case',
                          }}
                          image={cardItem.image}
                        />
                      </li>
                    ))}
                  </ul>
                  {item.viewAllLink && (
                    <div className="flex items-center justify-center py-3">
                      <LinkRenderer
                        cta={{
                          ...item.viewAllLink,
                          className: 'font-bold underline !text-base',
                        }}
                      />
                    </div>
                  )}
                </div>
              </AccordionContent>
            </div>
          </AccordionPanel>
        ))}
      </Accordion>
    </Flowbite>
  );
}

export default MenuDrawerAccordions;
